import { selectCurrentUserOrFail } from '../redux/slices/session'
import useAppSelector from './useAppSelector'

/**
 * Only use this hook in places where you're sure that the user is authenticated
 */
export function useCurrentUserOrFail() {
  return useAppSelector(selectCurrentUserOrFail)
}
